// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"159":"40b74181b98c3d66","717":"dc72acb485d46673","896":"9663993780c5298a"}[chunkId] + ".js";
};